/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import DomainIconComponent from 'bundles/browse-common/components/DomainIconComponent';
import PillGroup from 'bundles/browse-common/components/Pill/PillGroup';
import SectionHeadingComponent from 'bundles/browse-common/components/SectionHeadingComponent';
import TrackedPill from 'bundles/browse-common/components/TrackedPill';
import type { Domain } from 'bundles/browse-common/types/domain';

const styles = {
  label: css`
    margin-left: var(--cds-spacing-50);
  `,
};

type Props = {
  title: string;
  showPageTitleHeadingSize?: boolean;
  domains: Domain[];
};

const getTrackingData = (url: string) => {
  return {
    button: {
      name: 'browse_domain' as const,
      linkType: 'internal' as const,
      linkURL: url,
    },
  };
};

const DomainListComponent = (props: Props) => {
  const { title, domains, showPageTitleHeadingSize = false } = props;
  return (
    <div>
      <SectionHeadingComponent showPageTitleHeadingSize={showPageTitleHeadingSize}>{title}</SectionHeadingComponent>
      <PillGroup>
        {domains.map((domain) => {
          const url = `/browse/${domain.slug}`;
          return (
            <TrackedPill key={domain.slug} href={url} trackingData={getTrackingData(url)}>
              <DomainIconComponent domain={domain} />
              <span css={styles.label}>{domain.name}</span>
            </TrackedPill>
          );
        })}
      </PillGroup>
    </div>
  );
};

export default DomainListComponent;
